module.exports = __webpack_public_path__ + "images/titanfall_rgba(0,0,0,0.7).jpg?v=b9b8f91a45f9670727009d39f5257b2d";